<div class="song">
  <div class="song__cover">
    <div class="song__cover-letter">{{ label }}</div>
  </div>
  <div class="song__content song__content-more">
    <div class="song__name">
      <span class="song__name-link">{{ contact.title }}</span>
    </div>
    <div class="song__artist">
      <span class="song__artist-link">{{ contact.msisdn | mask: '+0 000 000-00-00' }}</span>
    </div>
  </div>
  <div class="song__more-controls" *ngIf="showControls && isNotDonator">
    <div class="song__more-controls-trigger icon icon-more" (click)="info()"></div>
  </div>
</div>
